const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the workshop type selection component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */

app.directive('workshopTypeSelection', ['Authorization', function (Authorization) {
  return {
    restrict: 'E',
    replace: true,
    scope: {},
    template: require('../../templates/directives/cms/workshop-type-selection.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.enabled = Authorization.getAuthToken().company.feature_flags.enable_multisession_workshops;
    }],
    controllerAs: "workshopType"
  };
}]);
